import React, { useState, useEffect } from "react";
import "../styles/accordnew.css";
import HistoryModel from "./HistoryModal";
import { totalOddsCal, formatValue } from "../helper/index"

const SubAccordion = ({
  data,
  oddsFormat,
  handleBetBuilderClose,
  loading,
  onClearAllSelections,
}) => {
  const [expandedIndex, setExpandedIndex] = useState([]);
  const [showHistory, setShowHistory] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);


  const handleOpenModal = (index) => {
    setShowHistory(index);
  };

  const handleCloseModal = () => {
    setShowHistory(null);
  };

  const toggleAccordion = (index) => {
  if (expandedIndex.includes(index)) {
    setExpandedIndex(expandedIndex.filter((i) => i !== index));
  } else {
    setExpandedIndex([...expandedIndex, index]);
  }
};

  const modifyWinLossStatus = (val) => {
    return val ? val.split(",") : [];
  };


  useEffect(() => {
  if (data?.length) {
    setExpandedIndex(data.map((_, idx) => idx));
  }
}, [data]);

const handleConfirmRemoveAll = () => {
  if (onClearAllSelections) {
    onClearAllSelections(); 
  }
  setShowConfirmModal(false);
};

  return (
    <>
      <div className="AF-hr"></div>

      <div className="AF-widget__accordionheader">
        <div className="grid-noGutter-middle">
          <div className="col-8_lg-8_md-8_sm-8_xs-8">
            <span className="AF-widget__title">BET BUILDER</span>{" "}
            <img src="assets/images/fire-icon.svg" alt="fire" />
          </div>
          {/* <div className="col-4_lg-4_md-4_sm-4_xs-4  AF-filter__list">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span
                className="AF-filterBy__txt"
                style={{ paddingRight: "2px" }}
              >
                Legs:
              </span>
              <div className="AF-select">
                <select
                  className="big-select"
                  onChange={handleStakeClick}
                  value={stake}
                  id='select-all-market-legs'
                >
                  {[1, 2, 3, 4].map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div className="section-remove-div">
        <span>Selection: <span className="data_length">{data.length}</span></span>{" "}
        <button onClick={() => setShowConfirmModal(true)}>Clear all selection</button>
      </div>

      <div className="accordion-sub">
        {data && data.map((item, i) => {
            const status = modifyWinLossStatus(item.form);
            return (
              <div className="accordion-item-new" key={i}>
                <button
                  className={`accordion-header-new ${expandedIndex.includes(i) ? "open" : ""}`}
                  onClick={() => toggleAccordion(i)}
                  id="btn_accordion_header_sub_market"
                >
                  {item.bestbetname}
                </button>
                <div
                  className={`accordion-content ${expandedIndex.includes(i) ? "show" : ""}`}
                >
                  <div className="column rtb-status">
                    <span>{item.rtb}</span>
                    <div className="win_loss_status">
                      {status.map((statusItem, j) => (
                        <React.Fragment key={j}>
                          {j <= 5 &&
                            (statusItem === "W" ? (
                              <span
                                className={`win_loss_badge win`}
                                onClick={() => handleOpenModal(i)}
                                id="btn_sub_market_history"
                              >
                                W
                              </span>
                            ) : statusItem === "L" ? (
                              <span
                                className={`win_loss_badge loss`}
                                onClick={() => handleOpenModal(i)}
                                id="btn_sub_market_history"
                              >
                                L
                              </span>
                            ) : (
                              <span
                                className={`win_loss_badge draw`}
                                onClick={() => handleOpenModal(i)}
                                id="btn_sub_market_history"
                              >
                                D
                              </span>
                            ))}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                  {item.odds.decimalodds === '1.01' || item.odds.decimalodds === null || item.odds.decimalodds == 0 || item.odds.decimalodds === 1.01 ? 
                    <div className="email-error-msg">Odds currently unavailable</div>
                    :
                    <div className="column button-container ">
                      <button className="btn-accordion">
                        {oddsFormat==='EU' ? parseFloat(item.odds.decimalodds).toFixed(2) : formatValue(item.odds.americanodds)}
                      </button>
                    </div>
                  }

                  {loading ? 
                    <div className="loading-container-newall">
                      <div className="spinner-newall"></div>
                    </div>
                    :
                    <div className="column progress-container">
                      <span className="">
                        <svg
                          className="icon2"
                          viewBox="0 0 24 24"
                          id="btn_sub_market_close"
                          onClick={() => handleBetBuilderClose(item.uniqueKey)}
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="18" y1="6" x2="6" y2="18" />
                          <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>

                      </span>
                    </div>
                  }
                </div>

                {showHistory === i && item.history && (
                  <div>
                    <HistoryModel
                      onClose={handleCloseModal}
                      onClick={handleOpenModal}
                      history={item.history}
                      play="soccer"
                    />
                  </div>
                )}
              </div>
            );
        })}
        <div className="AF-widget__footer p-0">
          <div className="grid-middle-noGutter">
            <div className="col-8_lg-8_md-8_sm-12_xs-12">
              <ul className="AF-totalOdds-stake-earn"></ul>
            </div>
            <div className="col-4_lg-4_md-4_sm-12_xs-12">
              <div className="AF-addAllToBetslip__btn">
                <ul className="AF-addAllToBetslip">
                    <li className="tooltip-wrapper">
                      <span className="odds_font_size">{totalOddsCal(oddsFormat, data)}</span>
                      <span className="tooltip-text">
                        Estimated odds, not official. Prices may differ; guidance only (not true/value odds).
                      </span>
                    </li>
                  </ul>
                {/* <ul className="AF-addAllToBetslip">
                  <li> {totalOddsCal(oddsFormat, data)}</li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>
        {showConfirmModal && (
          <div className="confirm-modal-overlay">
            <div className="confirm-modal">
              <h3>Clear Selection</h3>
              <p>Are you sure you want to clear all selections?</p>
              <div className="confirm-modal-buttons">
                <button className="cancel" onClick={() => setShowConfirmModal(false)}>Cancel</button>
                <button className="confirm" onClick={handleConfirmRemoveAll}>Clear</button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="AF-hr"></div>
    </>
  );
};

export default SubAccordion;
